import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useProjectCoshhContext } from 'components/contexts/ProjectCoshhContext';
import { getCoshhDocumentDetails } from 'components/projectCoshh/helpers';

export default function CoshhShow({ coshhDocument }) {
  const { comparisonValueForCustomValueUsage, secondaryFieldPlaceholder } =
    useProjectCoshhContext();

  const { t: i18nTCommon } = useTranslation('common');

  const coshhDocumentDetails = getCoshhDocumentDetails({
    comparisonValueForCustomValueUsage,
    coshhDocument,
    secondaryFieldPlaceholder,
    translations: {
      labels: {
        additionalInformation: i18nTCommon(
          'projects.coshh.controlMeasuresAndAdditionalInformation',
        ),
        exposureFrequency: i18nTCommon('projects.coshh.frequencyOfExposure'),
        levelOfRisk: i18nTCommon('projects.coshh.levelOfRisk'),
        location: i18nTCommon('projects.coshh.locationOfUse'),
        personsAtRisk: i18nTCommon('projects.coshh.personsAtRisk'),
        quantityOnSite: i18nTCommon('projects.coshh.quantityKeptOnSite'),
        quantityToBeUsed: i18nTCommon(
          'projects.coshh.quantityExpectedToBeUsed',
        ),
        staffNumber: i18nTCommon(
          'projects.coshh.numberOfPeopleInvolvedInActivity',
        ),
        substanceQuantityPerDay: i18nTCommon(
          'projects.coshh.quantityUsedInOneDay',
        ),
        uses: i18nTCommon('projects.coshh.methodOfUse'),
        workerExposureTime: i18nTCommon('projects.coshh.durationOfExposure'),
      },
    },
  });

  return (
    <div className='popup__body-show tw-p-0'>
      <div className='popup__body-content tw-pb-0'>
        {coshhDocumentDetails.map((documentDetail) => (
          <div className='tw-mb-6' key={documentDetail.label}>
            <div className='personal-info__label tw-mb-4 tw-font-medium'>
              {documentDetail.label}
            </div>
            <div
              className={classNames(
                'personal-info__text',
                !documentDetail.text && 'personal-info__text--not-added',
              )}
            >
              <span>
                {documentDetail.text || i18nTCommon('shared.notSpecified')}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

CoshhShow.propTypes = {
  coshhDocument: PropTypes.object.isRequired,
};
